const settingControls = [
    {
      chartType: "heatmap",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: true,
      showSortX: true,
      showSortY: true,
      showNormalize: true,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "onedheatmap",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: true,
      showSortX: true,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "worldmap",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: true,
      showSortX: false,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "barchart",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: true,
      showSortX: true,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "columnchart",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: true,
      showSortX: true,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "linechart",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: true,
      showSortZ: false,
      showSortX: true,
      showSortY: false,
      showNormalize: false,
      showRecency: false,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    },
    {
      chartType: "scatterplot",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: false,
      showSortZ: false,
      showSortX: false,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: false,
      showMetricX: true,
      showMetricY: true,
      showTypeCats: false
    },
    {
      chartType: "table",
      showTitle: true,
      showControls: true,
      showQuery: true,
      showColor: false,
      showSortZ: false,
      showSortX: false,
      showSortY: false,
      showNormalize: false,
      showRecency: true,
      showSize: true,
      showMetric: true,
      showMetricX: false,
      showMetricY: false,
      showTypeCats: false
    }
];

const defaultColorOptions = [
    { value: "size", text: "Size" },
    { value: "recency", text: "Recency" }
]

const defaultMetricOptions = [
    { value: "size", text: "Size" },
    { value: "recency", text: "Recency" }
]

const defaultSortOptions = [
    { value: "size", text: "Size" },
    { value: "recency", text: "Recency" }
]

export {
    settingControls,
    defaultColorOptions,
    defaultMetricOptions,
    defaultSortOptions
}